export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_SIRE_1.7ad8f779.jpg";